var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_location_vacancies",
          attrs: {
            id: "modal-location-vacancies",
            "content-class": "modal-fullscreen",
            "button-size": "sm",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "body-class": "p-0",
            "hide-header": ""
          },
          on: { hidden: _vm.onHidden },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-100 d-flex justify-content-between align-items-center"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex align-items-center",
                          staticStyle: { width: "40%" }
                        },
                        [
                          !_vm.hideLinkBtn
                            ? _c("location-select", {
                                ref: "location_select",
                                staticClass: "w-100",
                                attrs: {
                                  "is-disabled": _vm.isDisabled,
                                  value: _vm.locationId,
                                  "drop-up": ""
                                },
                                on: { onSelect: _vm.handleLocationSelect },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "append-btn",
                                      fn: function(ref) {
                                        var onClear = ref.onClear
                                        var query = ref.query
                                        var disabled = ref.disabled
                                        return [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                size: "sm",
                                                variant: _vm.locationId
                                                  ? "outline-danger"
                                                  : "outline-primary",
                                                disabled: disabled || !query
                                              },
                                              on: { click: onClear }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "mr-1",
                                                attrs: {
                                                  icon: _vm.locationId
                                                    ? "unlink"
                                                    : "link"
                                                }
                                              }),
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.locationId
                                                      ? "Отвязать объект"
                                                      : "Привязать объект"
                                                  ) +
                                                  "\n              "
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-2",
                              attrs: { size: "sm", variant: "secondary" },
                              on: {
                                click: function($event) {
                                  return _vm.hideModal()
                                }
                              }
                            },
                            [_vm._v("Отмена")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "success",
                                disabled: _vm.isDisabled
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleSaveVacancies()
                                }
                              }
                            },
                            [_vm._v("Сохранить")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("location-vacancies", {
            ref: "location_vacancies_component",
            attrs: {
              "show-details": "",
              "show-header": "",
              "is-disabled": _vm.isDisabled
            },
            on: { close: _vm.hideModal }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d7fadda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d7fadda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recruiting/RecruitLocationVacancy.vue
// module id = null
// module chunks = 